<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
    #app {
        color: #000000 !important;
        font-family: 'Noto Sans JP', sans-serif !important;
        font-size: 18px !important;
        line-height: 1.6;
    }

    .rexpanded {
        margin-left: 220px !important;
    }
</style>
